var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          staticClass: "trusted-id-modal",
          attrs: { scroll: "keep", "can-cancel": ["escape", "outside"] },
          model: {
            value: _vm.isTrustedIdNumbersCardModalActive,
            callback: function ($$v) {
              _vm.isTrustedIdNumbersCardModalActive = $$v
            },
            expression: "isTrustedIdNumbersCardModalActive",
          },
        },
        [
          _c("trusted-id-numbers", {
            on: {
              "is-modal-active": function ($event) {
                _vm.isTrustedIdNumbersCardModalActive = $event
              },
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "header-content" }, [
        _c(
          "a",
          {
            class:
              _vm.$store.state.currentUser == null
                ? "creditu-login-logo"
                : "creditu-logo",
            on: {
              click: () => {
                _vm.$router.push({ name: "dashboard" })
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/ui/assets/img/logo-creditu.svg"),
                alt: "logo-creditu",
              },
            }),
          ]
        ),
        _vm.$store.state.currentUser !== null
          ? _c(
              "div",
              {
                staticClass:
                  "header-item p-3 is-flex is-flex-direction-row-reverse is-align-items-center",
                class: { "scroll-active": _vm.isScrolling },
              },
              [
                _vm.currentUser !== null
                  ? _c(
                      "div",
                      {
                        staticClass: "bars-menu",
                        class: _vm.openMenu ? "active" : "",
                        on: { click: _vm.openMenuEmit },
                      },
                      [_c("span"), _c("span"), _c("span")]
                    )
                  : _vm._e(),
                _vm.$store.state.currentUser !== null
                  ? _c(
                      "div",
                      { staticClass: "user-menu" },
                      [
                        [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "is-pulled-right",
                              attrs: {
                                id: "dropdownMyProfile",
                                "aria-role": "list",
                                position: "is-bottom-left",
                                "mobile-modal": false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "trigger",
                                    fn: function () {
                                      return [
                                        _c("AvatarShow"),
                                        _c(
                                          "span",
                                          { staticClass: "user-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$store.state.currentUser !==
                                                  null
                                                  ? _vm.$store.state.currentUser
                                                      .user.name
                                                  : ""
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2445000420
                              ),
                            },
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  staticClass: "profile-my-account",
                                  attrs: { "aria-role": "listitem" },
                                  on: {
                                    click: () => {
                                      _vm.$router.push({
                                        name: "change-details",
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("sidebar.perfil")) + " "
                                  ),
                                ]
                              ),
                              _vm.$i18n.locale === "cl" &&
                              _vm.$store.state.currentUser &&
                              (_vm.$store.state.currentUser.user.allowedFrontRoutesNames?.includes(
                                "pay-here"
                              ) ||
                                _vm.$store.state.currentUser.user.allowedUserFeatures?.includes(
                                  "element.header.trusted-id"
                                ))
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      staticClass: "trusted-id",
                                      attrs: {
                                        id: "button-trusted-id-numbers",
                                        "data-cy": "button-trusted-id-numbers",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.isTrustedIdNumbersCardModalActive = true
                                        },
                                      },
                                    },
                                    [_vm._v(" Personas de confianza ")]
                                  )
                                : _vm._e(),
                              _vm.$store.state.currentUser.user.rol !== "CLIENT"
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      staticClass: "board-btn",
                                      attrs: {
                                        id: "button-board",
                                        "aria-role": "listitem",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openUrl("boards")
                                        },
                                      },
                                    },
                                    [_vm._v(" Board ")]
                                  )
                                : _vm._e(),
                              _vm.$store.state.currentUser.user.rol !== "CLIENT"
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      staticClass: "wiki-btn",
                                      attrs: {
                                        id: "button-wiki",
                                        "aria-role": "listitem",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openUrl("wiki")
                                        },
                                      },
                                    },
                                    [_vm._v(" Wiki ")]
                                  )
                                : _vm._e(),
                              _c(
                                "b-dropdown-item",
                                {
                                  staticClass: "profile-logout",
                                  attrs: {
                                    id: "button-logout",
                                    "aria-role": "listitem",
                                  },
                                  on: { click: _vm.logout },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("sidebar.logout")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.$store.state.currentUser &&
                (_vm.$store.state.currentUser.user.allowedFrontRoutesNames?.includes(
                  "support"
                ) ||
                  _vm.$store.state.currentUser.user.allowedUserFeatures?.includes(
                    "nav.sidebar.support"
                  ) ||
                  _vm.$store.state.currentUser.user.rol == "ADMIN" ||
                  _vm.$store.state.currentUser.user.rol == "CLIENT")
                  ? _c("div", { staticClass: "is-pulled-right config-menu" }, [
                      _c("div", { staticClass: "is-flex" }, [
                        _c(
                          "span",
                          { staticClass: "mr-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  id: "support-link",
                                  "data-cy": "support-link",
                                  "icon-left": "fas fa-headset",
                                  type: "is-primary",
                                },
                                on: {
                                  click: () => {
                                    _vm.$router.push({ name: "support" })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("clientRouter.help")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }